import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { SplashComponent } from './splash/splash.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ResComponent } from './res/res.component';
import { ContactComponent } from './contact/contact.component';
import { QuestionComponent } from './question/question.component';
import { GradeComponent } from './grade/grade.component';
import { OutlineComponent } from './outline/outline.component';

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    SplashComponent,
    ScheduleComponent,
    ResComponent,
    ContactComponent,
    QuestionComponent,
    GradeComponent,
    OutlineComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
